import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { BaseAnswerType, DefaultContinueHandlerType, RenderViewPropsType, RenderViewReturnType } from '../types';
import { RadioLikeButtonGroupWithImage } from '../../../React/features/Chat/features/RadioLikeButtonGroupWithImage';

export const COMPONENT_IDENTIFIER = 'radio-like-button-group-with-image';

export type RenderRadioLikeButtonGroupWithImagePropsType = RenderViewPropsType<{
  answers: Merge<Required<BaseAnswerType> & {
    imagePaths: {
      imagePath: string;
      webp: string;
    };
    balloonContents?: React.ReactNode;
  }>[];
}>

export const renderRadioLikeButtonGroupWithImage = async (props: RenderRadioLikeButtonGroupWithImagePropsType): RenderViewReturnType => {
  const { chatRoot, keyName } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // コンテナ要素にクラス付与
  viewContainer.classList.add(`chat-${COMPONENT_IDENTIFIER}-container`);
  viewContainer.classList.add(keyName);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: DefaultContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<RadioLikeButtonGroupWithImage {...props} continueHandler={continueHandler} />);
  });
};
